import { z } from 'zod';
import { API_KEY_SCOPES, WEBHOOK_EVENT_TYPES } from '../constants/webhookJobs.js';
export const projectApiKeyCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(200),
    scopes: z.array(z.enum(API_KEY_SCOPES)).min(1).default(['leads:read']),
});
export const webhookEndpointCreateSchema = z.object({
    project_id: z.string().uuid(),
    url: z.string().url().max(2000),
    events: z.array(z.enum(WEBHOOK_EVENT_TYPES)).min(1),
    enabled: z.boolean().default(true),
});
export const webhookEndpointPatchSchema = z.object({
    url: z.string().url().max(2000).optional(),
    events: z.array(z.enum(WEBHOOK_EVENT_TYPES)).min(1).optional(),
    enabled: z.boolean().optional(),
});
export const projectDomainSchema = z.object({
    project_id: z.string().uuid(),
    domain: z.string().min(1).max(253),
    note: z.string().max(500).optional().nullable(),
});
export const webhookTestSchema = z.object({
    event_type: z.enum(WEBHOOK_EVENT_TYPES).default('lead.created'),
});
//# sourceMappingURL=developer.js.map